import OadpAttribute from './oadp-attribute';
export default OadpAttribute;
